export const USER_INTEGRATIONS_SUCCESS = 'userintegrationSuccess';
export const USER_INTEGRATIONS_ERROR = 'userintegrationError';
export const OTHER_INTEGRATIONS_SUCCESS = 'otherintegrationSuccess';
export const OTHER_INTEGRATIONS_ERROR = 'otherintegrationError';
export const GET_USER_INTEGRATIONS = 'getUserIntegrations';
export const GET_OTHER_INTEGRATIONS = 'getOtherIntegrations';
export const REQUEST_INTEGRATIONS = 'requestIntegration';